import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  private snackbarSubject = new Subject<any>();
  public snackbarState = this.snackbarSubject.asObservable();

  public show(type: string, title: string, message: string ) {
    this.snackbarSubject.next({
      show: true,
      type,
      title,
      message
    })
  }
}
